// Called by application.js and loads all of our coffeescripts
function requireAll(r) {
    r.keys().forEach(r);
}
require('require-context/register')
requireAll(require.context('coffee', true, /\.coffee/));